import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/features/auth';
import { DEFAULT_AUTHENTICATED_ROUTE } from '@/config/routes';
import { usePermissions } from '@/features/auth/hooks/usePermissions';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * AdminRoute Component
 * Protected route wrapper for admin section access
 * RBAC: Allows OPERATOR, ADMIN, and SUPERADMIN roles
 * Individual tabs within admin section are filtered by role-specific permissions
 */
export function AdminRoute({ children }: AdminRouteProps) {
  const { user } = useAuthStore();
  const { canAccessAdminSection } = usePermissions();

  // Redirect to default route if user cannot access admin section (OPERATOR+ required)
  if (!user || !canAccessAdminSection()) {
    return <Navigate to={DEFAULT_AUTHENTICATED_ROUTE} replace />;
  }

  return <>{children}</>;
}
